<div class="overlay" *ngIf="fullscreen === 'true'; else spinner">
  <ng-container *ngTemplateOutlet="spinner"></ng-container>
</div>

<ng-template #spinner>
  <mat-spinner class="spinner"></mat-spinner>
</ng-template>
